function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H14C15.1 12 16 11.1 16 10V2C16 0.9 15.1 0 14 0ZM12.4 2L8 5.7L3.6 2H12.4ZM14 10H2V3.3L7.4 7.8C7.5 7.9 7.8 8 8 8C8.2 8 8.5 7.9 8.6 7.8L14 3.3V10Z",
  fill: "#860935"
});

function SvgMail({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAwSDJDMC45IDAgMCAwLjkgMCAyVjEwQzAgMTEuMSAwLjkgMTIgMiAxMkgxNEMxNS4xIDEyIDE2IDExLjEgMTYgMTBWMkMxNiAwLjkgMTUuMSAwIDE0IDBaTTEyLjQgMkw4IDUuN0wzLjYgMkgxMi40Wk0xNCAxMEgyVjMuM0w3LjQgNy44QzcuNSA3LjkgNy44IDggOCA4QzguMiA4IDguNSA3LjkgOC42IDcuOEwxNCAzLjNWMTBaIiBmaWxsPSIjODYwOTM1Ii8+Cjwvc3ZnPgo=";
export { SvgMail as ReactComponent };